import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/i18n/translations`

export default {
  get(key) {
    return ApiService.get(`${resourceUrl}?key=${key}&truncate=true`)
  },
  getInitial(key) {
    const initialUrl = `jsf/rest/i18n/translations`
    return ApiService.get(`${initialUrl}?key=${key}&truncate=true`)
  },
}
